export default __webpack_public_path__ + "static/media/gold-tag.7f31ca43.png";